import React, { useEffect } from 'react';
import './publicHome.scss';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';

export default function PublicHome() {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  useEffect(() => {
    if (!isAuthenticated) {
      instance.loginRedirect(loginRequest).catch((e: Error) => {
        console.log(e.message);
      });
    }
  }, [instance]);

  const apiUrl = process.env.REACT_APP_API_URL;
  const publicUrl = process.env.PUBLIC_URL;

  return (
    <React.Fragment>
      <div id="loading-screen">
        <img src="/spinner.gif" alt="Loading..." width="60" />
      </div>
    </React.Fragment>
  )
}
